import React from 'react'
import { useTable, useSortBy } from 'react-table'
import { Flex, Text, IconButton, Table, Thead, Tr, Th, Td, Tbody } from '@chakra-ui/react'

import {
  ChevronDownIcon,
  ChevronUpIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon
} from '@chakra-ui/icons'

const DataTh = ({ isSorted, isSortedDesc, children, ...props }) => (
  <Th {...props}>
    <Flex align='center'>
      {children}
      {isSorted &&
        (isSortedDesc ? <ChevronDownIcon boxSize='16px' /> : <ChevronUpIcon boxSize='16px' />)}
    </Flex>
  </Th>
)

export const DataTable = ({
  data = [],
  columns,
  onRowClick,
  fetchData,
  loading,
  onPage,
  pageIndex,
  pageCount
}) => {
  const { rows, prepareRow, headerGroups, getTableProps, getTableBodyProps } = useTable(
    {
      data,
      columns
    },
    useSortBy
  )

  return (
    <>
      <Table {...getTableProps()}>
        <Thead>
          {headerGroups.map(headerGroup => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <DataTh
                  isSorted={column.isSorted}
                  isSortedDesc={column.isSortedDesc}
                  width={column.width}
                  {...column.getHeaderProps(column.getSortByToggleProps())}>
                  <Text>{column.render('Header')}</Text>
                </DataTh>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {!loading &&
            rows.map((row, i) => {
              prepareRow(row)
              return (
                <Tr {...row.getRowProps()} cursor='pointer' _hover={{ background: '#F7FAFC' }} onClick={() => onRowClick && onRowClick(row)}>
                  {row.cells.map(cell => (
                    <Td {...cell.getCellProps()}>{cell.render('Cell')}</Td>
                  ))}
                </Tr>
              )
            })}
        </Tbody>
      </Table>
      {!loading && (
        <TablePagination
          onPage={onPage}
          pageIndex={pageIndex}
          pageCount={pageCount}
          // pageOptions={pageOptions}
          // pageCount={pageCount}
          // gotoPage={gotoPage}
          // setPageSize={setPageSize}
        />
      )}
    </>
  )
}

/*
export const Table = ({ caption, children, ...props }) => (
  <Box
    as='table'
    role='table'
    width='100%'
    maxWidth='100%'
    borderRadius='4px'
    {...props}
  >
    {caption && <VisuallyHidden as='caption'>{caption}</VisuallyHidden>}
    {children}
  </Box>
)

export const TableHead = props => <Box as='thead' {...props} />

export const TableRow = props => (
  <Flex
    as='tr'
    role='row'
    width='100%'
    direction={['column', 'row']}
    {...props}
  />
)

export const TableHeader = ({ isSorted, isSortedDesc, children, ...props }) => (
  <Flex
    as='th'
    scole='col'
    role='columnheader'
    textAlign='start'
    // justifyContent='space-between'
    px='6'
    py='3'
    // borderBottomWidth='1px'
    backgroundColor='gray.50'
    // sx={{
    //   'thead &': {
    //     backgroundColor: 'gray.50'
    //   },
    //   'tbody &': {
    //     backgroundColor: 'gray.30'
    //   }
    // }}
    flex={1}
    // fontSize='xs'
    // color='gray.500'
    // textTransform='uppercase'
    // letterSpacing='wider'
    // lineHeight='1rem'
    // fontWeight='medium'
    {...props}
  >
    {children}
    {isSorted &&
      (isSortedDesc ? (
        <ChevronDownIcon boxSize='20px' />
      ) : (
        <ChevronUpIcon boxSize='20px' />
      ))}
  </Flex>
)

export const TableBody = props => <Box as='tbody' width='100%' {...props} />


export const TableCell = ({ children, ...props }) => (
  <Box
    as='td'
    px='6'
    py='4'
    flex={1}
    borderBottomWidth='1px'
    // lineHeight='1.25rem'
    // whiteSpace='nowrap'
    {...props}
  >
    {children}
  </Box>
)
*/

const TablePagination = ({ onPage, pageIndex, pageCount }) => (
  <Flex
    paddingTop={3}
    borderTopWidth='1px'
    overflowX='hidden'
    overflowY='hidden'
    justifyContent='space-between'
    flexDirection='row'>
    <Flex flexDirection='row'>
      <IconButton
        mr={2}
        onClick={() => onPage(0)}
        isDisabled={pageIndex <= 0}
        icon={<ArrowLeftIcon />}
      />
      <IconButton
        mr={2}
        onClick={() => onPage(pageIndex - 1)}
        isDisabled={pageIndex <= 0}
        icon={<ChevronLeftIcon />}
      />
    </Flex>
    <Flex justifyContent='center' alignItems='center'>
      <Text mr={4}>
        Page{' '}
        <strong>
          {pageIndex + 1} of {pageCount}
        </strong>{' '}
      </Text>
    </Flex>
    <Flex flexDirection='row'>
      <IconButton
        ml={2}
        onClick={() => onPage(pageIndex + 1)}
        isDisabled={pageIndex >= pageCount - 1}
        icon={<ChevronRightIcon />}
      />
      <IconButton
        ml={2}
        onClick={() => onPage(pageCount - 1)}
        isDisabled={pageIndex >= pageCount - 1}
        icon={<ArrowRightIcon />}
      />
    </Flex>
  </Flex>
)
